import React from "react";
import withRollbar from "data/shared/withRollbar";
import { useRouteError } from "react-router-dom";
import { useRollbar } from '@rollbar/react';
import {ErrorHandler} from "ui/shared/components/ErrorHandler";

const RollbarErrorHandler = () => {
    let error = useRouteError();
    try {
        const rollbar = useRollbar();
        if(rollbar){
            rollbar.error(error.name, error);
        }
    } catch (rollbarError) {
        console.error(error);
    }
    return <ErrorHandler />
}

export default withRollbar(RollbarErrorHandler)